/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  record:
    | ModelRegistry['booking']
    | ModelRegistry['enquiry']
    | ModelRegistry['booking-request'];
}

interface BookingGuestImageSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiBookingGuestImageComponent = templateOnly<BookingGuestImageSignature>();

export default UiBookingGuestImageComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Guest::Image': typeof UiBookingGuestImageComponent;
  }
}
